import validate from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/node_modules/nuxt/dist/pages/runtime/validate.js";
import always_45run_45global from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/middleware/always-run.global.ts";
import auth_45global from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/middleware/auth.global.ts";
import pwa_45check_45global from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/middleware/pwa-check.global.ts";
import manifest_45route_45rule from "/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  always_45run_45global,
  auth_45global,
  pwa_45check_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  leaderauth: () => import("/Users/zhouxinrong/webroot/dagee/Platform/TourManage/view/middleware/leaderauth.ts")
}